module.exports = __webpack_public_path__ + "media/flags/dj-5216627a.svg";